import React from "react";

const MockupGenerator = () => {
  return (
    <div className="text-accent p-5">
      <h1 className="font-bold">Mockup generator</h1>
    </div>
  );
};

export default MockupGenerator;
